import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { style: { "display": "flex" } };
const _hoisted_2 = { style: { "padding-right": "10px" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DxCheckBox = _resolveComponent("DxCheckBox");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_DxCheckBox, _mergeProps({
                        id: identification,
                        readonly: _ctx.readOnly,
                        value: _ctx.internalValue,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event))
                    }, _ctx.inputAttrInternal), null, 16, ["id", "readonly", "value"])
                ]),
                _createElementVNode("div", null, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ])
        ]),
        _: 3
    }, 16, ["name", "error-message", "label"]));
}
